/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_MethodInputs */

const en_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Egly Method`)
};

const es_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El método Egly`)
};

const de_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-Methode`)
};

const zh_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const ar_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منهج Egly`)
};

const fr_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La méthode Egly`)
};

const vi_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương pháp Egly`)
};

const sw_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mbinu ya Egly`)
};

const th_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิธี Egly`)
};

const bs_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly metoda`)
};

const ja_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const ko_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly 메서드`)
};

const pt_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Método Egly`)
};

const it_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’Egly Method`)
};

const sv_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const nl_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Egly Method`)
};

const da_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const nb_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const fi_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const pl_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metoda Egly`)
};

const ru_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метод Egly`)
};

const tr_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const hi_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const id_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const ms_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const cs_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const el_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η Μέθοδος Egly`)
};

const he_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

const af_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-metode`)
};

const hu_footer_link_method = /** @type {(inputs: Footer_Link_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method`)
};

/**
* | output |
* | --- |
* | "The Egly Method" |
*
* @param {Footer_Link_MethodInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_link_method = /** @type {((inputs?: Footer_Link_MethodInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_MethodInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_link_method(inputs)
	if (locale === "de") return de_footer_link_method(inputs)
	if (locale === "zh") return zh_footer_link_method(inputs)
	if (locale === "ar") return ar_footer_link_method(inputs)
	if (locale === "fr") return fr_footer_link_method(inputs)
	if (locale === "vi") return vi_footer_link_method(inputs)
	if (locale === "sw") return sw_footer_link_method(inputs)
	if (locale === "th") return th_footer_link_method(inputs)
	if (locale === "bs") return bs_footer_link_method(inputs)
	if (locale === "ja") return ja_footer_link_method(inputs)
	if (locale === "ko") return ko_footer_link_method(inputs)
	if (locale === "pt") return pt_footer_link_method(inputs)
	if (locale === "it") return it_footer_link_method(inputs)
	if (locale === "sv") return sv_footer_link_method(inputs)
	if (locale === "nl") return nl_footer_link_method(inputs)
	if (locale === "da") return da_footer_link_method(inputs)
	if (locale === "nb") return nb_footer_link_method(inputs)
	if (locale === "fi") return fi_footer_link_method(inputs)
	if (locale === "pl") return pl_footer_link_method(inputs)
	if (locale === "ru") return ru_footer_link_method(inputs)
	if (locale === "tr") return tr_footer_link_method(inputs)
	if (locale === "hi") return hi_footer_link_method(inputs)
	if (locale === "id") return id_footer_link_method(inputs)
	if (locale === "ms") return ms_footer_link_method(inputs)
	if (locale === "cs") return cs_footer_link_method(inputs)
	if (locale === "el") return el_footer_link_method(inputs)
	if (locale === "he") return he_footer_link_method(inputs)
	if (locale === "af") return af_footer_link_method(inputs)
	if (locale === "hu") return hu_footer_link_method(inputs)
	return en_footer_link_method(inputs)
});